export default __webpack_public_path__ + "static/media/lukostrelba.4bfc714b.svg";